export default __webpack_public_path__ + "static/media/about-four-bg-shape.c0bde380.png";